import React, { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { FileUploader } from "react-drag-drop-files";

import { ReactComponent as ImagePlacholder } from "../../../../../assets/dashboard/avatar/gallery.svg";
import { ReactComponent as ImagePlacholderDark } from "../../../../../assets/dashboard/avatar/gallery-dark.svg";
import { ReactComponent as DownArrow } from "../../../../../assets/arrow-down.svg";
import { ReactComponent as DownArrowDark } from "../../../../../assets/arrow-down-dark.svg";
import { ReactComponent as SizeIcon } from "../../../../../assets/MainPage/addBlock/sizeIcon.svg";
import { ReactComponent as SizeIconDark } from "../../../../../assets/MainPage/addBlock/sizeIcon-dark.svg";
import { ReactComponent as ShapIcon } from "../../../../../assets/MainPage/addBlock/shape.svg";
import { ReactComponent as ShapIconDark } from "../../../../../assets/MainPage/addBlock/shape-dark.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import { toast } from "react-hot-toast";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import { useSelector } from "react-redux";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";

// This Form component is responsible for add and edit Avatar Block

const fileTypes = ["png", "jpg", "jpeg", "gif", "ico"];

const AvatarForm = ({
  formType,
  submitHandlerParent,
  deleteHandlerParent,
  prevData,
  avatarLoading,
}) => {
  const { darkMode } = useSelector((state) => state.theme);
  const { allLangs, tComponent, handleLanguageChange } =
    useLocales();
  const baseUrl = process.env.REACT_APP_API_URL;
  const [filePreview, setFilePreview] = useState(null);
  const [shapeAccordian, setShapeAccordian] = useState(false);
  const [sizeAccordian, setSizeAccordian] = useState(false);

  const [selectedShape, setSelectedShape] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);

  const [file, setFile] = useState(null);
  const handleChange = (file) => {
    setFile(file);
    setFilePreview(URL.createObjectURL(file));
  };
  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);

  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  useEffect(() => {
    if (prevData) {
      setFilePreview(
        prevData?.coloum_value?.name
          ? baseUrl + "/profile/" + prevData?.coloum_value?.name
          : null
      );
      setSelectedShape(prevData?.coloum_value?.radius);
      setSelectedSize(prevData?.coloum_value?.size);

      if (prevData?.language) {
        setSelectedLang(prevData?.language);
        const matchedLang = allLangs?.find(
          (lang) => lang.value === prevData?.language
        );
        const shouldSetLang = matchedLang?.label;
        setSelectedReporterType(shouldSetLang);
        handleLanguageChange(prevData?.language);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevData]);

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  const deleteHandler = () => {
    if (formType === "edit") {
      deleteHandlerParent("Editor");
    } else {
      console.log("ADDING");
    }
  };
  const submitHandler = () => {
    const linkid = localStorage.getItem("linkId");
    const userID = JSON.parse(localStorage.getItem("user")).userid;
    if (!file) {
      if (!filePreview) {
        toast.error("Please select a Image");
        return;
      }
    }
    if (selectedSize === "Size") {
      toast.error("Please select a Size");
      return;
    }
    if (selectedShape === "Shape") {
      toast.error("Please select a Shape");
      return;
    }
    const data = {
      coloum_name: "avatar",
      coloum_type: "avatar",
      size: selectedSize,
      radius: selectedShape,
      picture: file,
      link_id: linkid,
      user_id: userID,
      language: selectedLang,
    };
    submitHandlerParent(data);
  };

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
    <div
      className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
      style={{
        direction: selectedLang === "ar" ? "rtl" : "ltr",
      }}
    >
      <div className="border rounded-lg bg-light_bg_v5 dark:bg-dark-secondary p-[25px] dark:border-color_dark">
        <div className="flex justify-between items-center mb-[20px] sm:mb-[25px] ">
          <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
            {(formType === "edit" && tComponent(`avatar.${formType}`))}
            {(formType === "add" && tComponent(`avatar.${formType}`))}
            &nbsp;
            {tComponent("avatar.avatar")}
          </p>
          {formType === "add" && (
            <div className="flex items-center justify-center">
              <div className="relative w-[115px] sm:w-[145px]">
                <div
                  onClick={() => {
                    setSelectReporterTypeDropDown(!selectReporterTypeDropDown);
                  }}
                  className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                >
                  {selectedReporterType
                    ? selectedReporterType
                    : tComponent("avatar.select_lang")}
                  <DownArrow />
                </div>
                {selectReporterTypeDropDown && (
                  <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                    {allLangs?.map((item, i) => {
                      return (
                        <div
                          key={i}
                          onClick={() => {
                            setSelectedLang(item.value); // Set selected language code
                            setSelectedReporterType(item?.label);
                            setSelectReporterTypeDropDown(false);
                            handleChangeLang(item?.value);
                          }}
                          className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                        >
                          {item.label}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
          {formType === "edit" && (
            <div
              className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
            >
              {selectedReporterType ? selectedReporterType : "English"}
            </div>
          )}
        </div>
        {!filePreview && (
          <FileUploader
            handleChange={handleChange}
            name="file"
            types={fileTypes}
            maxSize={2}
            onSizeError={(errorMessage) => toast.error(errorMessage)}
            onTypeError={(errorMessage) => toast.error(errorMessage)}
            children={
              <div>
                <div className="flex items-center justify-center w-full">
                  <div className="flex flex-col items-center justify-center w-full py-[45px] px-5 border-2 border-dark_bg_v4 border-dashed rounded-lg cursor-pointer bg-light_bg_v5 dark:bg-dark-secondary hover:bg-gray-100 dark:border-color_dark dark:hover:border-gray-500 dark:hover:bg-gray-600">
                    <div className="flex flex-col items-center justify-center">
                      <div className="mb-[11px] h-[36px] w-[36]">
                        {darkMode ? (
                          <ImagePlacholderDark />
                        ) : (
                          <ImagePlacholder />
                        )}
                      </div>
                      <p className="text-small3 mb-[5px] whitespace-nowrap text-font_light_color dark:text-color_v2_dark">
                        {tComponent("avatar.drop_your_img")}, &nbsp;
                        <span className="text-small3_b text-main_color ">
                          {tComponent(`avatar.browse_image`)}
                        </span>
                      </p>
                      <p className="text-[10px] text-font_light_color dark:text-color_v2_dark tracking-[-0.3px] leading-[13px]">
                        2 MB {tComponent("avatar.maximum")}(.png, .gif,
                        .ico)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        )}
        {filePreview && (
          <div>
            <div className="flex items-center">
              <div className="bg-light_bg_v4 dark:bg-dark-secondary rounded-lg cursor-pointer">
                <img
                  className="h-[60px] w-[60px] sm:h-[68px] sm:w-[68px] p-1 object-cover rounded-lg"
                  src={filePreview}
                  alt=""
                />
              </div>
              <div>
                <FileUploader
                  handleChange={handleChange}
                  name="file"
                  types={fileTypes}
                  maxSize={2}
                  onSizeError={(errorMessage) => toast.error(errorMessage)}
                  onTypeError={(errorMessage) => toast.error(errorMessage)}
                  children={
                    <div className="ps-[15px] text-small2_b text-main_color cursor-pointer">
                      {tComponent("avatar.choose_another")}
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        )}
        <div className="mt-[15px]">
          <div>
            <div
              onClick={() => setSizeAccordian(!sizeAccordian)}
              className={`mt-2.5 p-[11px] px-[15px] cursor-pointer flex justify-between items-center ${
                sizeAccordian
                  ? "rounded-t-md bg-light_bg_v3 dark:bg-dark-primary"
                  : "rounded-md bg-light_bg_v4 dark:bg-dark-primary"
              }`}
            >
              <div className="flex items-center">
                {darkMode ? (
                  <SizeIconDark className=" w-auto" />
                ) : (
                  <SizeIcon className=" w-auto" />
                )}
                <div className="text-small2 md:text-small1 text-heading_color dark:text-color_v2_dark ps-3">
                  {(selectedSize && selectedSize) || tComponent("avatar.size")}
                </div>
              </div>
              <div className="text-2xl text-heading_color ">
                {darkMode ? <DownArrowDark /> : <DownArrow />}
                {/* <DownArrow /> */}
              </div>
            </div>
            {sizeAccordian && (
              <div className="rounded-b-md px-[26px] py-[30px] bg-white border-2 dark:bg-dark-secondary border-light_bg_v3 flex flex-wrap lg:flex-nowrap gap-[36px]">
                <div
                  onClick={() => setSelectedSize("75x75")}
                  className={`cursor-pointer flex justify-center items-center h-[70px] w-[70px] bg-main_color bg-opacity-10 ${
                    selectedSize === "75x75"
                      ? "outline outline-1 outline-offset-[5px]"
                      : ""
                  } `}
                >
                  <p className="text-small3_b dark:text-color_v2_dark text-center">
                    75x75
                  </p>
                </div>
                <div
                  onClick={() => setSelectedSize("100x100")}
                  className={`cursor-pointer flex justify-center items-center h-[100px] w-[100px] bg-main_color bg-opacity-10 ${
                    selectedSize === "100x100"
                      ? "outline outline-1 outline-offset-[5px]"
                      : ""
                  } `}
                >
                  <p className="text-small3_b dark:text-color_v2_dark text-center">
                    100x100
                  </p>
                </div>
                <div
                  onClick={() => setSelectedSize("125x125")}
                  className={`cursor-pointer flex justify-center items-center h-[125px] w-[125px] bg-main_color bg-opacity-10 ${
                    selectedSize === "125x125"
                      ? "outline outline-1 outline-offset-[5px]"
                      : ""
                  }`}
                >
                  <p className="text-small2_b dark:text-color_v2_dark text-center">
                    125x125
                  </p>
                </div>
                <div
                  onClick={() => setSelectedSize("150x150")}
                  className={`cursor-pointer flex justify-center items-center h-[150px] w-[150px] bg-main_color bg-opacity-10 ${
                    selectedSize === "150x150"
                      ? "outline outline-1 outline-offset-[5px]"
                      : ""
                  }`}
                >
                  <p className="text-small2_b dark:text-color_v2_dark text-center">
                    150x150
                  </p>
                </div>
              </div>
            )}
            <div
              onClick={() => setShapeAccordian(!shapeAccordian)}
              className={`mt-2.5 p-[11px] px-[15px] cursor-pointer flex justify-between items-center ${
                shapeAccordian
                  ? "rounded-t-md bg-light_bg_v3 dark:bg-dark-primary"
                  : "rounded-md bg-light_bg_v4 dark:bg-dark-primary"
              }`}
            >
              <div className="flex items-center">
                {darkMode ? (
                  <ShapIconDark className=" w-auto" />
                ) : (
                  <ShapIcon className=" w-auto" />
                )}
                <div className="text-small2 md:text-small1 capitalize text-heading_color dark:text-color_v2_dark ps-3">
                  {(selectedShape && selectedShape) || tComponent("avatar.shape")}
                </div>
              </div>
              <div className="text-2xl text-heading_color ">
                {darkMode ? <DownArrowDark /> : <DownArrow />}
              </div>
            </div>
            {shapeAccordian && (
              <div className="rounded-b-md px-[25px] py-[30px] bg-white border-2 dark:bg-dark-secondary border-light_bg_v3 flex flex-wrap gap-[36px]">
                <div
                  onClick={() => setSelectedShape("circle")}
                  className={`flex cursor-pointer justify-center items-center h-[100px] w-[100px] rounded-full bg-main_color bg-opacity-10 ${
                    selectedShape === "circle"
                      ? "outline outline-1 outline-offset-[5px]"
                      : ""
                  } `}
                >
                  <p className="text-small3_b dark:text-color_v2_dark text-center">
                    Circle
                  </p>
                </div>
                <div
                  onClick={() => setSelectedShape("rounded")}
                  className={`flex cursor-pointer justify-center items-center h-[100px] w-[100px] rounded-[17px] bg-main_color bg-opacity-10 ${
                    selectedShape === "rounded"
                      ? "outline outline-1 outline-offset-[5px]"
                      : ""
                  }`}
                >
                  <p className="text-small3_b dark:text-color_v2_dark text-center">
                    Rounded <br /> corners
                  </p>
                </div>
                <div
                  onClick={() => setSelectedShape("straight")}
                  className={`flex cursor-pointer justify-center items-center h-[100px] w-[100px] bg-main_color bg-opacity-10 ${
                    selectedShape === "straight"
                      ? "outline outline-1 outline-offset-[5px]"
                      : ""
                  }`}
                >
                  <p className="text-small3_b dark:text-color_v2_dark text-center">
                    Straight <br /> corners
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="flex mt-[26px] items-center justify-end">
          <button
            type="button"
            onClick={() => deleteHandler()}
            className="flex justify-center items-center"
          >
            {darkMode ? <TrashIconDark /> : <TrashIcon />}
            <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
              {tComponent("avatar.delete_cap")}
            </p>
          </button>
          <ExtraSmallFilledButton
            name={`${tComponent("avatar.save_cap")}`}
            buttonType={"button"}
            isLoading={avatarLoading}
            onClickHandler={submitHandler}
            classes={"ms-3"}
          />
        </div>
      </div>
    </div>
    </I18nextProvider>
  );
};

export default AvatarForm;
